import { useCallback, useMemo } from 'react';
import useSWR from 'swr';

import { commendaAiFeedbackKey, type CommendaAiWorkspaceId } from './api';
import { listCommendaAiMessageFeedback } from './listCommendaAiMessageFeedback';
import type { CommendaAiMessageFeedbackSummary } from './types';

export function useCommendaAiConversationFeedback(
  conversationId: string,
  companyId: CommendaAiWorkspaceId,
  isWorkspaceResolved: boolean
) {
  const {
    data: feedbackSummaries,
    isLoading,
    error,
    mutate,
  } = useSWR(
    commendaAiFeedbackKey(conversationId, companyId, isWorkspaceResolved),
    ([, id]) => listCommendaAiMessageFeedback(id)
  );

  const feedbackByMessageId = useMemo(
    () =>
      new Map<string, CommendaAiMessageFeedbackSummary>(
        (feedbackSummaries ?? []).map((summary) => [
          summary.messageId,
          summary,
        ])
      ),
    [feedbackSummaries]
  );

  const revalidateFeedback = useCallback(() => {
    mutate().catch(() => undefined);
  }, [mutate]);

  return { feedbackByMessageId, isLoading, error, revalidateFeedback };
}
